<template>
  <BaseCard :title="'RPG Battle Simulator'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Solo Engineer</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">April 2025 - May 2025</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          One of my favorite parts of taking on a new project is becoming so invested in it that it's near impossible to stop.
          The ideas just keep on flowing and I can't seem to break away from the keyboard, which is exactly the case with this project.
        </span>
        <span class="block">
          What I originally intended to be a short, 10-hour project to develop a small interface to do a single turn of battle turned
          into a 75-hour project. In just over a week, I designed 6 player classes, 2 unique sprites, 2 menus, and 6 animations for each move,
          all within the painfully simple <a href="https://www3.nd.edu/~dthain/courses/cse20211/fall2013/gfx/" class="link-in-text" target="_blank">GFX</a> library that can't do more
          than draw a single shape at a time. I learned that I needed to clear and redraw the entire screen to 
          animate moving frames, yet it was all worth it for the final product. I still sometimes play it to this day!
        </span>
        <a href="https://youtu.be/EPzwJwWxlPI" target="_blank" class="link-in-text">Watch a demo!</a>
      </p>
      <span class="flex flex-col place-items-center overflow-hidden">
        <img class="rounded-lg w-full h-auto cursor-pointer" :src="FFGif" @click="openImageMenu(FFGif, 'Battle Sim Short Demo', $event.currentTarget)" style="width: 40%; margin: auto">
      </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import FFGif from '@/assets/Projects/FinalFantasyPhotos/FFGif.gif';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>